import styles from "./GeneratingSpinner.module.scss";

export const GeneratingSpinner = () => {
  return (
    <div className={styles["spinnerWrapper"]}>
      <div className={styles["spinner"]} />
      <p className={styles["spinnerText"]}>生成中...</p>
    </div>
  );
};
